import React from 'react';
import loadable from '@loadable/component';
import AnimatedLoader from 'components/BelowTheFoldControl/AnimatedLoader';
import { styled } from '@nykaa/ui-components';

const Loading = styled(AnimatedLoader)`
  height: 100px;
`;

const Games = loadable(() => import('./Games'), {
  fallback: <Loading className="client" />,
});

export default Games;
